import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/Frontend-web-next/src/page-components/directory/DirectoryDetail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/Frontend-web-next/src/page-components/directory/DirectoryIndex.tsx");
